var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Multiselect',{attrs:{"id":"titles","options":_vm.titles,"label":"label","track-by":"uuid","placeholder":"Choose Title(s)","multiple":true},model:{value:(_vm.selectedTitles),callback:function ($$v) {_vm.selectedTitles=$$v},expression:"selectedTitles"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }